<div class="practice-data-unavailable-container">
  <img src="../../assets/images/no-practice-data.svg" />
  <p>No practice data is available.</p>
  <p>
    Freckle data is only available for students rostered through Renaissance.
  </p>
  <p class="new-text">
    New to Freckle?
    <a
      href="https://www.renaissance.com/products/freckle/"
      class="freckle-link"
      target="_blank"
      >Learn more</a
    >
  </p>
</div>
